import { Route } from '@angular/router';
import { routes } from '@padspin/web';

export const appRoutes: Route[] = routes;
